import React from 'react'
import './PrivacyPolicy.css'

const TermsAndConditions = () => {
  return (
    <div className='termsandconditions privacypolicy container'>
        <p style={{paddingTop:'150px'}}><b>Terms and Conditions</b></p>
        <p><b>Effective Date :</b>2025</p><br/>

        <p>
            We’re glad to have you at Artical Art an Interior Hub. The following Terms and Conditions outline the rules and guidelines for using our website (www.articalart.com) as well as the services we offer.
            By visiting our site or making use of our services, you are agreeing to follow and accept these terms. If you do not agree with any part of these terms, we kindly ask that you do not use our services.
        </p>

        <h4>1. Scope of Services</h4>
            <p>
               Artical Art offers a range of services including interior design consultations, 3D visual design solutions, comprehensive interior design services, and full project implementation. 
               The availability of these services may vary, and we reserve the right to modify or discontinue any service at any time without prior notification.
            </p><br/>

        <h4>2. Payment Terms</h4>
            <ul>
                <li>Service prices are provided either on our website or as specified in a formal agreement or contract.</li>
                <li>A non-refundable advance payment may be required before any work begins.</li>
                <li>Full payment must be completed prior to the delivery of final designs or the completion of the project.</li>
                <li>Late payments may cause delays in the project and could result in additional charges.</li>
            </ul><br/>

        <h4>3. Project Timelines & Delivery</h4>
        <ul>
            <li>Estimated completion timelines will be shared with the client at the beginning of the project.</li>
            <li>Interior X Design is not liable for delays caused by unexpected events such as material unavailability or issues with external vendors.</li>
            <li>Clients are expected to provide prompt feedback and approvals to help maintain the project schedule and avoid unnecessary delays.</li>
        </ul><br/>

        <h4>4. Client Responsibilities</h4>
        <ul>
            <li>Clients are required to supply precise measurements of their space along with any relevant documentation needed for the project.</li>
            <li>Clear communication of design preferences and timely responses to approval requests are essential.</li>
            <li>Any modifications requested after a design has been approved may lead to extra charges and could result in extended project timelines.</li>
        </ul><br/>

        <h4>5. Intellectual Property </h4>
        <ul>
            <li>All design materials, including drawings and creative concepts developed by Artical Art, remain the intellectual property of the company unless a written agreement states otherwise.</li>
            <li>Clients are not permitted to reproduce, share, or alter any of our designs without obtaining prior written permission.</li>
        </ul><br/>

        <h4>6. Third-Party Vendors & Liability</h4>
            <ul>
                <li>Interior X Design may suggest third-party vendors, such as contractors or furniture suppliers, to support your project needs.</li>
                <li>We do not assume responsibility for the quality, performance, or timeliness of services provided by these third parties.</li>
                <li>We are not liable for any damages, defects, or delays resulting from the actions or products of external vendors.</li>
            </ul><br/>

        <h4>7. Cancellations & Refunds</h4>
        <ul>
            <li>Requests to cancel services must be submitted in writing.</li>
            <li>Any deposit that is designated as non-refundable will not be returned under any circumstances.</li>
            <li>When applicable, refunds will be calculated and issued based on the amount of work completed up until the date the cancellation is received.</li>
        </ul><br/>

        <h4>8. Privacy Policy</h4>
        <ul>
            <li>We safeguard your personal information in accordance with our established Privacy Policy.</li>
            <li>Client data will not be disclosed to any third parties without your explicit permission.</li>
        </ul><br/>


        <h4>9. Dispute Resolution</h4>
        <ul>
            <li>Efforts will be made to settle any disagreements through friendly and cooperative discussions initially.</li>
            <li>If a resolution cannot be reached, the dispute will be referred to arbitration held in Mumbai ,Maharashtra, following the relevant laws.</li>
            <li>Any legal matters will fall under the jurisdiction of [Insert Jurisdiction].</li>
        </ul><br/>

        <h4>10. Changes to Terms</h4>
        <ul>
            <li>Interior X Design holds the right to modify or revise these terms and conditions at any time without prior notice.</li>
            <li>By continuing to use our website or services after any changes are made, you agree to accept and abide by the updated terms.</li>
        </ul><br/>

        <h4>11. Contact Information</h4>
        <p>If you have any questions or need clarification about these Terms and Conditions, please reach out to us at:</p>
        {/* <p>Email: support@articalart.com</p> */}
        <p>Email :<a href = 'mailto:support@articalart.com'> <span>support@articalart.com</span></a></p>

        {/* <p>Website: www.articalart.com</p><br/> */}
        <p>Website : <a href='https://articalart.com'>www.articalart.com</a></p>




        <p>By utilizing our services, you confirm that you have carefully read, fully understood, and willingly accepted these Terms and Conditions.</p>


    </div>
  )
}

export default TermsAndConditions